import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchRecitationAudio } from '../../../apis/FetchData'; // Import your API function
import { useLocation, useNavigate } from 'react-router-dom';
import 'reactjs-popup/dist/index.css';
import AudioBarUi from "../Ui/AudioBarUi"
import shuffleIcon from '../../../assets/images/shuffle.svg';
import shuffleIconWhite from '../../../assets/images/shuffleWhite.svg';
import arrow_down_blue from '../../../assets/images/arrow_down_blue.svg';
import arrow_down_White from '../../../assets/images/arrow_down_white.svg';
import move_next from '../../../assets/images/move_next.svg';
import move_nextWhite from '../../../assets/images/move_nextWhite.svg';
import move_previous from '../../../assets/images/move_previous.svg';
import move_previousWhite from '../../../assets/images/move_previousWhite.svg';
import play_black from '../../../assets/images/play_black.svg';
import play_White from '../../../assets/images/play_white.svg';
import pause_black from '../../../assets/images/pause_black.svg'
import pause_White from '../../../assets/images/pause_white.svg'
import { SettingsReducer } from "../../../redux/Setting"
import { useTranslation } from 'react-i18next';
import { convertToSearchableChapters } from './SearchableChapters';
import { message } from 'antd';
const SettingActions = SettingsReducer.actions;

let globalFirstVerseFetchGuard = null;
let globalFetchDataGuard = null;

//forwardRef, For calling child function in Parent component
const RecitationComponent = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const chapters = useSelector((state) => state.chapters);
  const reciterNames = useSelector((state) => state.chapters.reciters);
  const selectedReciterId = useSelector((state) => state.settings.selectedReciterId);
  const selectedReciterName = useSelector((state) => state.settings.selectedReciterName);
  const rawShuffle = useSelector((state) => state.settings.shuffle);
  const shuffle = rawShuffle != null ? parseInt(rawShuffle, 10) : 3;
  const playState = useSelector((state) => state.settings.playState);
  const translationLoading = useSelector((state) => state.settings.translationLoading);
  const persistedRangeFromChapter = useSelector((state) => state.settings.rangeFromChapter);
  const persistedRangeToChapter = useSelector((state) => state.settings.rangeToChapter);
  const persistedRangeFromVerse = useSelector((state) => state.settings.rangeFromVerse);
  const persistedRangeToVerse = useSelector((state) => state.settings.rangeToVerse);
  const [recitations, setRecitations] = useState([]);
  const [firstVerse, setFirstVerse] = useState([]);
  const rawPlayingSurah = useSelector((state) => state.settings.playingSurah);
  const playingSurah = rawPlayingSurah != null ? parseInt(rawPlayingSurah, 10) : 1;
  const rawPlayingVerse = useSelector((state) => state.settings.playingVerse);
  const playingVerse = rawPlayingVerse != null ? parseInt(rawPlayingVerse, 10) : 1;
  const [lastPlayedVerseIndex, setLastPlayedVerseIndex] = useState(null);
  const [selectedOptionChapter, setSelectedOptionChapter] = useState(null);
  const [selectedOptionFromChapter, setSelectedOptionFromChapter] = useState(null);
  const [selectedOptionToChapter, setSelectedOptionToChapter] = useState(null);
  const [audioSrc, setAudioSrc] = useState('');
  const [selectedSurah, setSelectedSurah] = useState(1);
  const [selectedVerse, setSelectedVerse] = useState(1);
  const [verseLength, setverseLength] = useState(1);
  const [open, setOpen] = useState(false);
  const [openShuffle, setOpenShuffle] = useState(false);
  const [rangeOfVerses, setRangeOfVerses] = useState({
    fromVerse: 1,
    toVerse: 5,
  });
  const [isListenAllChaptersActive, setIsListenAllChaptersActive] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasPlayingBeforeOffline, setWasPlayingBeforeOffline] = useState(false);
  const [hasShownOfflineAlert, setHasShownOfflineAlert] = useState(false);
  const [searchReciterQuery, setSearchReciterQuery] = useState('');
  const [showPlayFromModal, setShowPlayFromModal] = useState(false);
  const [playFromModalSurah, setPlayFromModalSurah] = useState(1);
  const [playFromModalVerse, setPlayFromModalVerse] = useState(1);

  const userTheme = useSelector((state) => state.settings.userTheme);
  const shuffle_Icon = userTheme === 'Dark' ? shuffleIconWhite : shuffleIcon;
  const arrowDownBlue = userTheme === 'Dark' ? arrow_down_White : arrow_down_blue;
  const moveNext = userTheme === 'Dark' ? move_nextWhite : move_next;
  const movePrevious = userTheme === 'Dark' ? move_previousWhite : move_previous;
  const playBlackWhite = userTheme === 'Dark' ? play_White : play_black;
  const pauseBlackWhite = userTheme === 'Dark' ? pause_White : pause_black;
  const audioRef = useRef(null);
  const hasInitializedRangeFromPersist = useRef(false);
  const reciterChangeHandledRef = useRef(false);
  const isChangingReciterRef = useRef(false);
  const ChapterOptions = convertToSearchableChapters(chapters);
  let pauseThis = false;

  // redux-persist can restore a previous "playing" state from older sessions.
  // Ensure audio bar always starts paused on fresh app load.
  useEffect(() => {
    dispatch(SettingActions.updateSettings({ playState: false }));
  }, [dispatch]);

  const fetchData = async () => {
    if (selectedSurah && selectedReciterName && verseLength) {
      const fetchId = `${selectedReciterId}-${selectedSurah}-${selectedVerse}-${verseLength}`;
      if (globalFetchDataGuard === fetchId) return;
      globalFetchDataGuard = fetchId;
      try {
        // console.log("selectedSurah:",selectedSurah," / ","selectedVerse:",selectedVerse," / ","verseLength:",verseLength)
        const response = await fetchRecitationAudio(selectedReciterId, selectedSurah, selectedVerse, verseLength);
        setRecitations(response && response.status === 200 && response.data);
        // console.log("recitations:",response.data)
      } catch (error) {
        console.error('Error fetching recitations:', error);
      }
    }
  };

  useEffect(() => {
    if (!selectedSurah || (!playState && audioRef.current)) {
      const chapterRouteMatch = location.pathname.match(/^\/(\d+)\/(\d+)\/?$/);
      if (chapterRouteMatch) {
        const routeSurah = parseInt(chapterRouteMatch[1], 10);
        const routeVerse = parseInt(chapterRouteMatch[2], 10);
        setSelectedSurah(routeSurah);
        setSelectedVerse(routeVerse);
        dispatch(SettingActions.updateSettings({ playingSurah: routeSurah }));
        // Only auto-play if not in "Listen All Chapters" mode
        if (!isListenAllChaptersActive) {
          dispatch(SettingActions.updateSettings({ playingVerse: routeSurah > 1 && routeVerse === 1 ? 1111 : routeVerse }));// For playing  بِسْمِ ٱللَّٰهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ 
        }
      } else if (location.pathname === "/") {
        setSelectedSurah(1);
        setSelectedVerse(1);
      }
    }
  },
    // eslint-disable-next-line
    [location, dispatch, selectedSurah, selectedVerse, isListenAllChaptersActive]);

  useEffect(() => {
    // Find the option object with the specific ID (props.selectedSurah) and set it as the selected option
    setSelectedOptionChapter(ChapterOptions.find(option => option.value === selectedSurah));
  }, [ChapterOptions, selectedSurah]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (hasInitializedRangeFromPersist.current) return;
    if (!ChapterOptions || ChapterOptions.length === 0) return;

    const chapterOneOption = ChapterOptions.find((option) => parseInt(option.value, 10) === 1) || ChapterOptions[0];
    if (!chapterOneOption) return;

    const fromChapterValue = parseInt(persistedRangeFromChapter, 10);
    const toChapterValue = parseInt(persistedRangeToChapter, 10);
    const fromVerseValue = parseInt(persistedRangeFromVerse, 10);
    const toVerseValue = parseInt(persistedRangeToVerse, 10);

    const fromChapterOption = ChapterOptions.find((option) => parseInt(option.value, 10) === fromChapterValue) || chapterOneOption;
    const toChapterOption =
      ChapterOptions.find(
        (option) =>
          parseInt(option.value, 10) === toChapterValue &&
          parseInt(option.value, 10) >= parseInt(fromChapterOption.value, 10)
      ) || fromChapterOption;

    const safeFromVerse = Number.isFinite(fromVerseValue) && fromVerseValue >= 1 ? fromVerseValue : 1;
    const safeToVerseBase = Number.isFinite(toVerseValue) && toVerseValue >= 1 ? toVerseValue : 5;
    const isSameChapter = parseInt(fromChapterOption.value, 10) === parseInt(toChapterOption.value, 10);
    const safeToVerse = isSameChapter ? Math.max(safeFromVerse, safeToVerseBase) : safeToVerseBase;

    setSelectedOptionFromChapter(fromChapterOption);
    setSelectedOptionToChapter(toChapterOption);
    setRangeOfVerses({
      fromVerse: safeFromVerse,
      toVerse: safeToVerse,
    });

    hasInitializedRangeFromPersist.current = true;
  }, [ChapterOptions, persistedRangeFromChapter, persistedRangeToChapter, persistedRangeFromVerse, persistedRangeToVerse]);

  useEffect(() => {
    if (!selectedOptionFromChapter || !selectedOptionToChapter) return;

    const payload = {
      rangeFromChapter: parseInt(selectedOptionFromChapter.value, 10),
      rangeToChapter: parseInt(selectedOptionToChapter.value, 10),
      rangeFromVerse: rangeOfVerses.fromVerse,
      rangeToVerse: rangeOfVerses.toVerse,
    };

    if (
      payload.rangeFromChapter === persistedRangeFromChapter &&
      payload.rangeToChapter === persistedRangeToChapter &&
      payload.rangeFromVerse === persistedRangeFromVerse &&
      payload.rangeToVerse === persistedRangeToVerse
    ) {
      return;
    }

    dispatch(SettingActions.updateSettings(payload));
  }, [
    dispatch,
    selectedOptionFromChapter,
    selectedOptionToChapter,
    rangeOfVerses.fromVerse,
    rangeOfVerses.toVerse,
    persistedRangeFromChapter,
    persistedRangeToChapter,
    persistedRangeFromVerse,
    persistedRangeToVerse,
  ]);


  useEffect(() => {
    if (!playState) {
      let totalVerses = chapters.chapters[parseInt(selectedSurah) - 1];
      setverseLength(totalVerses && totalVerses.totalVerses);
      // console.log("inside fetch data, now totalVerses",totalVerses)
      if (totalVerses && recitations && totalVerses.totalVerses && parseInt(totalVerses.totalVerses) !== recitations.length) {
        // console.log("Now same, fetch again")
        fetchData()
      }
    }
  },
    // eslint-disable-next-line
    [location, chapters.chapters, selectedSurah, playState, playingVerse]);

  const handleReciterChange = async (reciterid, recitername) => {
    if (parseInt(reciterid, 10) === parseInt(selectedReciterId, 10)) {
      return;
    }

    // Capture the current verse BEFORE any state changes to avoid race conditions
    // with onEnded/playNextVerse advancing the verse.
    const surahToPlay = playingSurah || selectedSurah || 1;
    const verseToPlay = shuffle === 4
      ? parseInt(rangeOfVerses.fromVerse, 10) || 1
      : (playingVerse === 0 ? 1111 : (playingVerse || selectedVerse || 1));
    const wasPlaying = playState;

    // IMMEDIATELY kill the old audio element to prevent onEnded from firing
    // and calling playNextVerse during the reciter switch.
    isChangingReciterRef.current = true;
    if (audioRef.current && audioRef.current.audioEl && audioRef.current.audioEl.current) {
      try {
        audioRef.current.audioEl.current.pause();
        audioRef.current.audioEl.current.removeAttribute('src');
        audioRef.current.audioEl.current.load();
      } catch (e) {
        // Ignore errors from stopping audio
      }
    }

    dispatch(SettingActions.updateSettings({ selectedReciterId: reciterid }));
    dispatch(SettingActions.updateSettings({ selectedReciterName: recitername }));

    // Always replay the current verse with the new reciter, whether playing or not.
    // Using reciterIdOverride to fetch audio from the new reciter immediately,
    // preventing the useEffect([selectedReciterId]) from double-handling this.
    reciterChangeHandledRef.current = true;
    try {
      await playVerse(surahToPlay, verseToPlay, wasPlaying || true, true, reciterid);
    } finally {
      isChangingReciterRef.current = false;
    }
  };

  const handleReciterSearch = (event) => {
    setSearchReciterQuery(event.target.value);
  };

  const filteredReciters = reciterNames.filter(
    (reciter) =>
      reciter.reciter.toLowerCase().includes(searchReciterQuery.toLowerCase())
  );

  const handleShuffleChange = (shuffleId) => {
    dispatch(SettingActions.updateSettings({ shuffle: shuffleId }));
    // Set flag for "Listen All Chapters" mode
    setIsListenAllChaptersActive(shuffleId === 3);
  };

  const playVerse = async (playChapterNoRaw, verseIndexRaw, play_pause, resetRecitations, reciterIdOverride = null) => {
    const playChapterNo = parseInt(playChapterNoRaw, 10) || 1;
    let verseIndex = (verseIndexRaw !== undefined && verseIndexRaw !== null) ? parseInt(verseIndexRaw, 10) : undefined;
    const activeReciterId = reciterIdOverride ?? selectedReciterId;

    // Prevent playback when offline
    if (play_pause && !isOnline) {
      message.warning(t('no-internet-connection') || 'No internet connection. Please check your connection and try again.');
      return;
    }

    // Check if we're switching to a different chapter - compare with currently playing chapter from Redux
    const isDifferentChapter = playChapterNo !== playingSurah;

    // Update local state to keep in sync with what's being played
    setSelectedSurah(playChapterNo)
    if (verseIndex !== undefined && verseIndex !== null) {
      setSelectedVerse(verseIndex === 1111 ? 0 : verseIndex);
    }

    // If starting "Listen All Chapters" from Chapter 1, Verse 1, set the flag
    if (shuffle === 3 && playChapterNo === 1 && verseIndex === 1) {
      setIsListenAllChaptersActive(true);
    }

    try {
      if (!verseIndex) {
        dispatch(SettingActions.updateSettings({ playingVerse: parseInt(selectedVerse) }));
        verseIndex = selectedVerse
      }

      if (verseIndex === undefined) {
        verseIndex = lastPlayedVerseIndex !== null ? lastPlayedVerseIndex : 0;
      }

      if (playChapterNo > 1 && parseInt(verseIndex, 10) === 1 && resetRecitations) {
        verseIndex = 1111;
      }

      // Update Redux state for playing chapter and verse
      dispatch(SettingActions.updateSettings({ playingSurah: playChapterNo }));
      dispatch(SettingActions.updateSettings({ playingVerse: verseIndex === 1111 ? 0 : verseIndex }));

      // Handle special case for verse 1111 (Bismillah)
      if (verseIndex === 1111) {
        if (reciterIdOverride != null || !firstVerse || firstVerse.length === 0) {
          try {
            const response = await fetchRecitationAudio(activeReciterId, 1, 1, 1);
            if (response?.status === 200 && response.data?.[0]) {
              setFirstVerse([response.data[0]]);
              setAudioSrc(response.data[0].url);
            }
          } catch (error) {
            console.error('Error fetching bismillah for new reciter:', error);
          }
        } else {
          let src = firstVerse.filter(item => item.verseNo === 1 && item.chapNo === 1);
          if (src.length > 0) {
            setAudioSrc(src[0].url);
          } else {
            try {
              const response = await fetchRecitationAudio(activeReciterId, 1, 1, 1);
              if (response?.status === 200 && response.data?.[0]) {
                setFirstVerse([response.data[0]]);
                setAudioSrc(response.data[0].url);
              }
            } catch (error) {
              console.error('Error fetching bismillah fallback:', error);
            }
          }
        }
        setLastPlayedVerseIndex(verseIndex);
        dispatch(SettingActions.updateSettings({ playState: play_pause }));
        return;
      }

      // When switching chapters, fetch new recitations first
      if (resetRecitations || isDifferentChapter || reciterIdOverride != null) {
        let totalVerses = chapters.chapters[parseInt(playChapterNo) - 1];
        setverseLength(totalVerses && totalVerses.totalVerses);

        try {
          // Fetch recitations for the new chapter
          const response = await fetchRecitationAudio(activeReciterId, playChapterNo, verseIndex || 1, totalVerses?.totalVerses || 1);
          if (response && response.status === 200) {
            setRecitations(response.data);

            // Find and set the audio source for the requested verse
            const src = response.data.filter(item => parseInt(item.verseNo, 10) === parseInt(verseIndex, 10) && parseInt(item.chapNo, 10) === parseInt(playChapterNo, 10));
            if (src.length > 0) {
              setAudioSrc(src[0].url);
              setLastPlayedVerseIndex(verseIndex);
              dispatch(SettingActions.updateSettings({ playState: play_pause }));
            }
          }
        } catch (error) {
          console.error('Error fetching recitations for new chapter:', error);
        }
      } else {
        // Same chapter - use existing recitations or fetch if needed
        if (recitations && recitations.length > 0) {
          let src = recitations.filter(item => parseInt(item.verseNo, 10) === parseInt(verseIndex, 10) && parseInt(item.chapNo, 10) === parseInt(playChapterNo, 10));
          if (src.length > 0) {
            setAudioSrc(src[0].url);
            setLastPlayedVerseIndex(verseIndex);
            dispatch(SettingActions.updateSettings({ playState: play_pause }));
          } else {
            // Recitations exist but verse not found - refetch
            const response = await fetchRecitationAudio(activeReciterId, playChapterNo, verseIndex, verseLength);
            if (response && response.status === 200) {
              setRecitations(response.data);
              const newSrc = response.data.filter(item => parseInt(item.verseNo, 10) === parseInt(verseIndex, 10) && parseInt(item.chapNo, 10) === parseInt(playChapterNo, 10));
              if (newSrc.length > 0) {
                setAudioSrc(newSrc[0].url);
                setLastPlayedVerseIndex(verseIndex);
                dispatch(SettingActions.updateSettings({ playState: play_pause }));
              }
            }
          }
        } else {
          // No recitations loaded - fetch them
          let totalVerses = chapters.chapters[parseInt(playChapterNo) - 1];
          setverseLength(totalVerses && totalVerses.totalVerses);
            const response = await fetchRecitationAudio(activeReciterId, playChapterNo, verseIndex || 1, totalVerses?.totalVerses || 1);
          if (response && response.status === 200) {
            setRecitations(response.data);
            const src = response.data.filter(item => parseInt(item.verseNo, 10) === parseInt(verseIndex, 10) && parseInt(item.chapNo, 10) === parseInt(playChapterNo, 10));
            if (src.length > 0) {
              setAudioSrc(src[0].url);
              setLastPlayedVerseIndex(verseIndex);
              dispatch(SettingActions.updateSettings({ playState: play_pause }));
            }
          }
        }
      }
    }
    catch (error) {
      console.log(error)
    }
  };


  useEffect(() => {
    const fetchFirstAyat = async () => {
      // If handleReciterChange already called playVerse, skip this effect.
      if (reciterChangeHandledRef.current) {
        reciterChangeHandledRef.current = false;
        return;
      }
      
      if (globalFirstVerseFetchGuard === selectedReciterId) return;
      globalFirstVerseFetchGuard = selectedReciterId;
      
      if (playState === true) {
        const surahToPlay = playingSurah || selectedSurah || 1;
        const verseToPlay = shuffle === 4
          ? parseInt(rangeOfVerses.fromVerse, 10) || 1
          : (playingVerse === 0 ? 1111 : (playingVerse || selectedVerse || 1));
        playVerse(surahToPlay, verseToPlay, true, true, selectedReciterId);
      }
      else {
        const responseFirstVerse = await fetchRecitationAudio(selectedReciterId, 1, 1, 1);
        setFirstVerse(responseFirstVerse && responseFirstVerse.status === 200 ? [responseFirstVerse.data[0]] : []);
      }
    };
    fetchFirstAyat();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReciterId]);

  useEffect(() => {
    if (!playState) {
      fetchData();
    }
  },
    // eslint-disable-next-line
    [chapters.chapters, selectedSurah, verseLength, selectedReciterName, selectedReciterId, selectedVerse, location, playState]);

  const Pause = () => {
    dispatch(SettingActions.updateSettings({ playState: false }));
    pauseThis = true
    // Clear the "Listen All Chapters" flag when pausing
    setIsListenAllChaptersActive(false);
    // Reset offline alert flag when manually pausing
    setHasShownOfflineAlert(false);
    setWasPlayingBeforeOffline(false);
  }

  const playNextVerse = () => {
    // Skip if a reciter change is in progress to prevent race conditions
    // where the old audio's onEnded fires during the switch.
    if (isChangingReciterRef.current) {
      console.log("playNextVerse SKIPPED - reciter change in progress");
      return;
    }
    console.log("---------- playNextVerse ----------");
    console.log("shuffle => ", shuffle);
    console.log("playingSurah => ", playingSurah);
    console.log("playingVerse => ", playingVerse);

    const currentSurah = playingSurah || 1;
    const currentVerse = (playingVerse === 1111 || playingVerse === 0) ? 0 : playingVerse;
    const totalVerses = chapters.chapters[currentSurah - 1]?.totalVerses || 1;

    if (shuffle === 4) {
      const toChapter = parseInt(persistedRangeToChapter, 10) || 1;
      const toVerse = parseInt(persistedRangeToVerse, 10) || 1;

      if (currentVerse === 0) {
        playVerse(currentSurah, 1, true, false);
        return;
      }

      if (currentSurah === toChapter && currentVerse === toVerse) {
        Pause();
        return;
      }

      const nextVerse = currentVerse + 1;
      if (nextVerse <= totalVerses) {
        if (currentSurah === toChapter && nextVerse > toVerse) {
          Pause();
          return;
        }
        playVerse(currentSurah, nextVerse, true, false);
      } else {
        if (currentSurah < toChapter) {
          const nextChapter = currentSurah + 1;
          const chapterRoutePattern = /^\/\d+\/\d+\/?$/;
          const isOnChapterView = location.pathname === "/" || chapterRoutePattern.test(location.pathname);
          if (isOnChapterView) {
            navigate("/" + nextChapter + "/1");
          }
          playVerse(nextChapter, 1111, true, true);
        } else {
          Pause();
        }
      }
      return;
    }

    if (shuffle === 2) {
      if (currentVerse === 0) {
        playVerse(currentSurah, 1, true, false);
        return;
      }
      const nextVerse = currentVerse + 1;
      if (nextVerse <= totalVerses) {
        playVerse(currentSurah, nextVerse, true, false);
      } else {
        playVerse(currentSurah, 1, true, false);
      }
      return;
    }

    if (shuffle === 3) {
      if (currentVerse === 0) {
        playVerse(currentSurah, 1, true, false);
        return;
      }
      const nextVerse = currentVerse + 1;
      if (nextVerse <= totalVerses) {
        playVerse(currentSurah, nextVerse, true, false);
      } else {
        if (currentSurah < 114) {
          const nextChapter = currentSurah + 1;
          const chapterRoutePattern = /^\/\d+\/\d+\/?$/;
          const isOnChapterView = location.pathname === "/" || chapterRoutePattern.test(location.pathname);
          if (isOnChapterView) {
            navigate("/" + nextChapter + "/1");
          }
          playVerse(nextChapter, 1111, true, true);
        } else {
          Pause();
        }
      }
      return;
    }

    if (currentVerse === 0) {
      playVerse(currentSurah, 1, true, false);
      return;
    }
    const nextVerse = currentVerse + 1;
    if (nextVerse <= totalVerses) {
      playVerse(currentSurah, nextVerse, true, false);
    }
  };

  const playPreviousVerse = () => {
    const currentSurah = playingSurah || 1;
    const currentVerse = (playingVerse === 1111 || playingVerse === 0) ? 0 : playingVerse;

    if (shuffle === 4) {
      const fromChapter = parseInt(persistedRangeFromChapter, 10) || 1;
      const fromVerse = parseInt(persistedRangeFromVerse, 10) || 1;

      if (currentSurah === fromChapter && currentVerse === fromVerse) {
        return;
      }

      if (currentVerse > 1) {
        const prevVerse = currentVerse - 1;
        if (currentSurah === fromChapter && prevVerse < fromVerse) {
          return;
        }
        playVerse(currentSurah, prevVerse, true, false);
      } else {
        if (currentSurah > fromChapter) {
          const prevChapter = currentSurah - 1;
          const prevTotalVerses = chapters.chapters[prevChapter - 1]?.totalVerses || 1;
          const chapterRoutePattern = /^\/\d+\/\d+\/?$/;
          const isOnChapterView = location.pathname === "/" || chapterRoutePattern.test(location.pathname);
          if (isOnChapterView) {
            navigate("/" + prevChapter + "/" + prevTotalVerses);
          }
          playVerse(prevChapter, prevTotalVerses, true, true);
        }
      }
      return;
    }

    if (shuffle === 2) {
      if (currentVerse > 1) {
        playVerse(currentSurah, currentVerse - 1, true, false);
      } else {
        const totalVerses = chapters.chapters[currentSurah - 1]?.totalVerses || 1;
        playVerse(currentSurah, totalVerses, true, false);
      }
      return;
    }

    if (shuffle === 3) {
      if (currentVerse > 1) {
        playVerse(currentSurah, currentVerse - 1, true, false);
      } else {
        if (currentSurah > 1) {
          const prevChapter = currentSurah - 1;
          const prevTotalVerses = chapters.chapters[prevChapter - 1]?.totalVerses || 1;
          const chapterRoutePattern = /^\/\d+\/\d+\/?$/;
          const isOnChapterView = location.pathname === "/" || chapterRoutePattern.test(location.pathname);
          if (isOnChapterView) {
            navigate("/" + prevChapter + "/" + prevTotalVerses);
          }
          playVerse(prevChapter, prevTotalVerses, true, true);
        }
      }
      return;
    }

    if (currentVerse > 1) {
      playVerse(currentSurah, currentVerse - 1, true, false);
    }
  };

  const onMenuOpen = () => {
    setTimeout(() => {
      const selectedEls = document.getElementsByClassName("MyDropdown__option--is-selected");
      for (let i = 0; i < selectedEls.length; i++) {
        if (selectedEls[i]) {
          selectedEls[i].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
        }
      }
    }, 15);
  };

  const handleChapterChange = (e) => {
    setSelectedOptionFromChapter(e);
    // Reset "To Chapter" if it's before the new "From Chapter"
    if (
      selectedOptionToChapter &&
      parseInt(selectedOptionToChapter.value, 10) < parseInt(e.value, 10)
    ) {
      setSelectedOptionToChapter(e);
    }
    // Clear both verse fields when changing "From Chapter"
    setRangeOfVerses(prevRange => ({
      ...prevRange,
      fromVerse: '',
      toVerse: ''
    }));
    navigate("/" + e.value + "/1");
    document.getElementById('chapterContent').scrollTop = 0;
  }

  const handleChapterToChange = (e) => {
    if (
      selectedOptionFromChapter &&
      parseInt(e.value, 10) < parseInt(selectedOptionFromChapter.value, 10)
    ) {
      return;
    }
    setSelectedOptionToChapter(e);
    // Clear "To Verse" when changing "To Chapter"
    setRangeOfVerses(prevRange => ({
      ...prevRange,
      toVerse: ''
    }));
  }

  const handleFromVerseChange = (value) => {
    setRangeOfVerses(prevRange => {
      const newRange = {
        ...prevRange,
        fromVerse: value,
      };

      // Only reset "To Verse" if both chapters are the same and "To Verse" is less than or equal to the new "From Verse"
      if (selectedOptionFromChapter && selectedOptionToChapter &&
        selectedOptionFromChapter.value === selectedOptionToChapter.value &&
        prevRange.toVerse && prevRange.toVerse <= value) {
        newRange.toVerse = '';
      }

      return newRange;
    });
  }

  // Network connectivity monitoring
  useEffect(() => {
    const handleOnline = async () => {
      setIsOnline(true);
      setHasShownOfflineAlert(false);

      // Auto-resume playback if it was playing before going offline
      if (wasPlayingBeforeOffline && audioRef.current && audioSrc) {
        message.success(t('internet-connection-restored') || 'Internet connection restored. Resuming playback...');
        try {
          // Update play state and resume playback
          dispatch(SettingActions.updateSettings({ playState: true }));
          await audioRef.current.audioEl.current.play();
        } catch (error) {
          console.error('Error resuming playback:', error);
          // If play fails, try to reload the audio source
          if (audioRef.current && audioRef.current.audioEl.current) {
            audioRef.current.audioEl.current.load();
            try {
              await audioRef.current.audioEl.current.play();
            } catch (retryError) {
              console.error('Error retrying playback:', retryError);
            }
          }
        }
        setWasPlayingBeforeOffline(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);

      // If currently playing, pause and show alert
      if (playState && audioRef.current) {
        setWasPlayingBeforeOffline(true);
        dispatch(SettingActions.updateSettings({ playState: false }));
        if (audioRef.current.audioEl.current) {
          audioRef.current.audioEl.current.pause();
        }

        // Show alert only once per offline session
        if (!hasShownOfflineAlert) {
          message.warning(t('no-internet-connection') || 'No internet connection. Playback paused.');
          setHasShownOfflineAlert(true);
        }
      }
    };

    // Check initial online status
    setIsOnline(navigator.onLine);

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasPlayingBeforeOffline, hasShownOfflineAlert, playState, audioSrc, t, dispatch]);

  useEffect(() => {
    if (playState && !pauseThis && audioRef.current && isOnline && audioSrc && !translationLoading) {
      audioRef.current.audioEl.current.play().catch(error => {
        console.error("Error playing audio inside useEffect:", error);
      });
    } else if (!playState && audioRef.current) {
      audioRef.current.audioEl.current.pause();
    }

  }, [playState, pauseThis, isOnline, audioSrc, translationLoading]);

  const closeModal = () => {
    setOpen(false);
    setSearchReciterQuery(''); // Reset search query when closing modal
  };
  const closeModalShuffle = () => setOpenShuffle(false);

  // Play-from modal only: use current chapter/verse from Home when provided; else fall back to internal state (no change to other flows).
  const currentSurah = props.currentSurah != null ? props.currentSurah : selectedSurah;
  const currentVerse = props.currentVerse != null ? props.currentVerse : (selectedVerse === 1111 ? 1 : selectedVerse);
  const isOnChapterPage = location.pathname === "/" || /^\/\d+\/\d+\/?$/.test(location.pathname);

  const getVerseInViewFromChapterContent = () => {
    // There can be more than one element with this id in modal contexts.
    // Pick the visible, scrollable chapter container from the page.
    const containers = Array.from(document.querySelectorAll('#chapterContent'));
    const container = containers.find((el) => {
      const isVisible = el.offsetParent !== null;
      const isScrollable = el.scrollHeight > el.clientHeight;
      return isVisible && isScrollable;
    }) || containers.find((el) => el.offsetParent !== null) || null;
    if (!container) return null;
    const verseEls = container.querySelectorAll('[data-verse-no]');
    if (!verseEls || verseEls.length === 0) return null;

    const containerRect = container.getBoundingClientRect();
    const visibleTop = containerRect.top + 80;
    let bestVerse = null;
    let bestDiff = Infinity;

    verseEls.forEach((el) => {
      const verseNo = parseInt(el.getAttribute('data-verse-no'), 10);
      if (!Number.isFinite(verseNo)) return;
      const rect = el.getBoundingClientRect();
      const diff = rect.top - visibleTop;
      if (diff <= 0) {
        if (-diff < bestDiff) {
          bestDiff = -diff;
          bestVerse = verseNo;
        }
      } else if (diff < bestDiff) {
        bestDiff = diff;
        bestVerse = verseNo;
      }
    });

    return bestVerse;
  };

  // When user taps main Play and they are not at verse 1, show dialog to choose start point.
  const handleMainPlayClick = () => {
    if (playState) {
      playVerse(playingSurah, shuffle === 4 ? parseInt(rangeOfVerses.fromVerse) : playingVerse, false, false);
      return;
    }
    if (shuffle === 4) {
      playVerse(playingSurah, parseInt(rangeOfVerses.fromVerse), true, true);
      return;
    }
    const verseInView = getVerseInViewFromChapterContent();
    const effectiveCurrentSurah = currentSurah || playingSurah || selectedSurah;
    let effectiveCurrentVerse = (isOnChapterPage && verseInView != null) ? verseInView : currentVerse;

    if (effectiveCurrentVerse === 1 && effectiveCurrentSurah > 1) {
      effectiveCurrentVerse = 1111;
    }

    // Show dialog only on chapter pages when playback is idle and user is not at verse 1.
    const isAtStart = effectiveCurrentVerse === 1111 || effectiveCurrentVerse === 0 || effectiveCurrentVerse === 1;
    if (!playState && isOnChapterPage && effectiveCurrentSurah && effectiveCurrentVerse > 1 && !isAtStart) {
      setPlayFromModalSurah(effectiveCurrentSurah);
      setPlayFromModalVerse(effectiveCurrentVerse);
      setShowPlayFromModal(true);
      return;
    }
    playVerse(effectiveCurrentSurah, effectiveCurrentVerse || 1, true, true);
  };

  const handlePlayFromStart = () => {
    setShowPlayFromModal(false);
    playVerse(playFromModalSurah, 1, true, true);
  };

  const handlePlayFromCurrentVerse = () => {
    setShowPlayFromModal(false);
    const verseInView = getVerseInViewFromChapterContent();
    const currentVerseToPlay = verseInView != null ? verseInView : playFromModalVerse;
    const currentSurahToPlay = playFromModalSurah || currentSurah || playingSurah || selectedSurah;
    playVerse(currentSurahToPlay, currentVerseToPlay, true, true);
  };

  const handleAudioPlay = () => {
    // Keep Play/Pause UI synced without re-selecting verse during audio element play event.
    if (!playState) {
      dispatch(SettingActions.updateSettings({ playState: true }));
    }
  };

  // For Calling child function in Parent component
  useImperativeHandle(ref, () => ({ playVerse }));

  const setAudioSrcToTHis = (url) => {
    // Set props.audioSrc to the desired URL
    setAudioSrc(url);
    navigate('/' + parseInt(selectedSurah + 1) + '/' + 1);
  };

  return (
    <AudioBarUi
      translationLoading={translationLoading}
      t={t} reciterNames={reciterNames} selectedReciterId={selectedReciterId} selectedReciterName={selectedReciterName}
      shuffle={shuffle} playState={playState} recitations={recitations} playingVerse={playingVerse} audioSrc={audioSrc}
      open={open} setOpen={setOpen} openShuffle={openShuffle} setOpenShuffle={setOpenShuffle} audioRef={audioRef}
      pauseThis={pauseThis} handleReciterChange={handleReciterChange} handleShuffleChange={handleShuffleChange}
      playVerse={playVerse} playNextVerse={playNextVerse} playPreviousVerse={playPreviousVerse} closeModal={closeModal}
      closeModalShuffle={closeModalShuffle} playBlackWhite={playBlackWhite} pauseBlackWhite={pauseBlackWhite}
      onMainPlayClick={handleMainPlayClick}
      onAudioPlay={handleAudioPlay}
      showPlayFromModal={showPlayFromModal} setShowPlayFromModal={setShowPlayFromModal}
      playFromModalSurah={playFromModalSurah} playFromModalVerse={playFromModalVerse}
      onPlayFromStart={handlePlayFromStart} onPlayFromCurrentVerse={handlePlayFromCurrentVerse}
      shuffle_Icon={shuffle_Icon} arrowDownBlue={arrowDownBlue} moveNext={moveNext} movePrevious={movePrevious}
      selectedSurah={selectedSurah} selectedVerse={playingVerse} Pause={Pause} playingSurah={playingSurah}
      firstVerse={firstVerse} setAudioSrc={setAudioSrc} setAudioSrcToTHis={setAudioSrcToTHis}
      rangeOfVerses={rangeOfVerses} setRangeOfVerses={setRangeOfVerses} handleChapterChange={handleChapterChange} handleChapterToChange={handleChapterToChange} handleFromVerseChange={handleFromVerseChange}
      ChapterOptions={ChapterOptions} selectedOptionChapter={selectedOptionChapter} selectedOptionToChapter={selectedOptionToChapter}
      selectedOptionFromChapter={selectedOptionFromChapter} onMenuOpen={onMenuOpen} dispatch={dispatch} SettingActions={SettingActions}
      navigate={navigate} userTheme={userTheme} chapters={chapters}
      searchReciterQuery={searchReciterQuery} handleReciterSearch={handleReciterSearch} filteredReciters={filteredReciters}
    />
  );
});

export default RecitationComponent;
